import { HttpClient } from '@angular/common/http'
import { EventEmitter, inject, Injectable } from '@angular/core'
import { CoreEnvironmentService } from '../core-environment.service'
import { TrackLikeInfoEvent, UpdateBeatLikeStatusParams } from './like-info.types'

@Injectable({
  providedIn: 'root'
})
export class LikeInfoApiService {
  private readonly coreEnvironmentService = inject(CoreEnvironmentService)
  private readonly http = inject(HttpClient)

  changeTrackLikeInfoEvent = new EventEmitter<TrackLikeInfoEvent>(null)

  private readonly baseUrl = this.coreEnvironmentService.getBaseURL()
  private likeType = 'Beats'

  updateBeatLikeStatus({ beatId, likeStatus }: UpdateBeatLikeStatusParams): void {
    const payload = {
      itemId: beatId,
      like: likeStatus,
      type: this.likeType
    }

    this.http.post(`${this.baseUrl}/Likes/Likes/AddLike`, payload).subscribe({
      next: () => this.changeTrackLikeInfoEvent.emit({ beatId }),
      complete: () => {}
    })
  }
}
